export const VendedorEntity = {
    id: null,
    numeroDocumento: '',
    nombres: '',
    apellidos: '',
    telefono: '',
    email: '',
    tipoDocumento: 'DNI',
    enabled: true,
    jefeVentas: null
};